import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from '@material-ui/core/styles';
import { TextField, IconButton, InputAdornment } from '@material-ui/core/';

import { TEXT_INPUT, TEXT_INPUT_BACKGROUND, TEXT_INPUT_BORDER } from '../../constants/constants';
import { IInputFieldProps, ITextFieldProps, ITextFieldSuffixProps } from '../../constants/commonTypes';

const useTextFieldStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: TEXT_INPUT_BACKGROUND,
    border: TEXT_INPUT_BORDER + ' 1px solid',
    borderRadius: 4,
    overflow: 'hidden',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: TEXT_INPUT_BACKGROUND,
    },
    '&$focused': {
      backgroundColor: TEXT_INPUT_BACKGROUND,
      borderColor: TEXT_INPUT_BORDER,
    },
  },
  focused: {},
}));


const theme = createMuiTheme({
  palette: {
    primary: {
      main: TEXT_INPUT
    },
  },
});
const ClearInput = (props: ITextFieldSuffixProps) => {

  const { onClick, element, value } = props;
  if (value) {
    return (
      <InputAdornment position="end">
        <IconButton
          onClick={onClick}
        >
          {element}
        </IconButton>
      </InputAdornment>
    )
  }
  return <></>
}

function InputField(props: IInputFieldProps) {
  const classes = useTextFieldStyle();

  const { suffix, value, suffixOnClick, onKeyPress, suffixElement, handleOnChange,disabled,  ...rest } = props;

  const suffixBtn = suffix ? <ClearInput onClick={(e) => suffixOnClick(e)} value={value} element={suffixElement} /> : null

  return (
    <TextField
      InputProps={{
        classes,
        disableUnderline: true,
        endAdornment: suffixBtn
      }}
      autoComplete="off"
      onChange={handleOnChange}
      value={value}
      onKeyPress={onKeyPress}
      disabled={disabled}
      {...rest}
    />
  );
}

const TextInput = (props: ITextFieldProps) => {

  const { value, label, customStyle, type, suffix, onKeyPress, suffixOnClick, variant, suffixElement, handleOnChange,disabled,  ...rest } = props;

  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <InputField
          label={label}
          className={customStyle}
          variant={variant}
          suffix={suffix}
          suffixOnClick={(e) => suffixOnClick(e)}
          suffixElement={suffixElement}
          handleOnChange={(e) => handleOnChange(e)}
          type={type}
          value={value}
          onKeyPress={onKeyPress}
          disabled={disabled}
          {...rest}
        />
      </ThemeProvider>
    </Fragment>
  )
}

TextInput.defaultProps = {
  label: '',
  customStyle: {},
  type: 'text',
  handleOnChange: () => { },
  variant: "filled",
  suffix: false,
  suffixOnClick: () => { },
  suffixElement: null,
  value: ''
}

TextInput.propTypes = {
  label: PropTypes.string,
  customStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  handleOnChange: PropTypes.func,
  type: PropTypes.string,
  variant: PropTypes.string,
  suffix: PropTypes.bool,
  suffixOnClick: PropTypes.func,
  suffixElement: PropTypes.node,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fullWidth: PropTypes.bool
}

export default TextInput;
